export default "__VITE_ASSET__DlWx0qOV__"